module.exports = __webpack_public_path__ + "img/society-marie-curie-avatar.aa065b28.png";